import { render, staticRenderFns } from "./EmbedExtensionView.vue?vue&type=template&id=50f26a0c&scoped=true&"
import script from "./EmbedExtensionView.vue?vue&type=script&lang=js&"
export * from "./EmbedExtensionView.vue?vue&type=script&lang=js&"
import style0 from "./EmbedExtensionView.vue?vue&type=style&index=0&id=50f26a0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f26a0c",
  null
  
)

export default component.exports